import { LoginVerificationContact } from 'src/app/models/login-verification-model/login-verification-contact.model';

export class LoginVerificationChallenge {

  private challengeId: string;
  private contacts: LoginVerificationContact[];

  constructor(challengeId?: string, contacts?: LoginVerificationContact[]) {
    this.challengeId = challengeId;
    this.contacts = contacts;
  }

  public get ChallengeId() {
    return this.challengeId;
  }

  public get Contacts() {
    return this.contacts;
  }

  public set ChallengeId(challengeId) {
    this.challengeId = challengeId;
  }

  public set Contacts(contacts) {
    this.contacts = contacts;
  }
}
